import React, {FC} from 'react';
import {useSelector} from 'react-redux';
import {IState} from "../../types/state";
import cls from "./shared.module.scss"
import {useGlobal} from "../../hooks/useGlobal";

const Currency: FC<any> = ({value, handleCommas}) => {
    const {selectedRate} = useGlobal()
    const symbol = selectedRate && selectedRate.symbol
    const locale = "catchAll"
    const symbolStore = "$"

    value = isNaN(Number(Number(value).toFixed(selectedRate?.name === "AMD" ? 0 : 2) as string)) ?
        value :
        Number(value).toFixed(selectedRate?.name === "AMD" ? 0 : 2)
    const trueSymbol = symbol || symbolStore

    return (
        <div className={cls["currency_value"]}>
            {/*{locale === 'hy' ? (*/}
            {/*    <>*/}
            {/*        <span>{`${handleCommas ? String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : value}`}</span>*/}
            {/*        <span>{!isNaN(value) ? trueSymbol : ""}</span>*/}
            {/*    </>*/}
            {/*) : (*/}
                <>
                    {' '}
                    <span>{!isNaN(value) ? trueSymbol : ""}</span>
                    <span>{`${handleCommas ? String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : value}`}</span>

                </>
            {/*)}*/}
        </div>
    )
}

export default Currency
